import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const swiperOptions = {
	modules: [Autoplay, Pagination, Navigation],
	slidesPerView: 1,
	spaceBetween: 30,
	autoplay: {
		delay: 2500,
		disableOnInteraction: false,
	},
	loop: true,
	navigation: {
		nextEl: ".h1n",
		prevEl: ".h1p",
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
};

export default function Testimonial1() {
	return (
		<div className="tf-widget-testimonial background-black">
			<div className="themeflat-container">
				<div className="tf-testimonial">
					<div className="row">
						<div className="col-md-12 col-lg-7 col-xl-7 col-xxl-7">
							<div className="wow fadeInLeft animated">
								<Swiper
									{...swiperOptions}
									className="swiper-testimonial owl-theme"
									style={{ paddingBottom: "20px" }}
								>
							  {/* Testimonial Slide #1 */}
								<SwiperSlide>
                    <div className="tf-testimonial-content">
                      <div className="user-info">
                        <img
                          className="icon-testimonil"
                          src="images/testimonial/Graphic.png"
                          alt=""
                        />
                        <div className="avata">
                          <img
                            src="images/testimonial/profile.jpg"
                            alt="profile1"
                          />
                        </div>
                        <div className="info">
                          <h6 className="name">Sarah B.</h6>
                          <p className="post">Parent of U10 Player</p>
                        </div>
                      </div>
                      <div className="content">
                        <div className="start">
                          {[...Array(5)].map((_, i) => (
                            <svg
                              key={i}
                              width={20}
                              height={20}
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.80979 0.58541C9.86966 0.401148 10.1303 0.401148 10.1902 0.58541L12.2002 6.77163C12.227 6.85404 12.3038 6.90983 12.3904 6.90983H18.895C19.0888 6.90983 19.1693 7.15775 19.0126 7.27163L13.7503 11.0949C13.6802 11.1459 13.6508 11.2361 13.6776 11.3185L15.6876 17.5048C15.7475 17.689 15.5366 17.8422 15.3799 17.7284L10.1176 13.9051C10.0475 13.8541 9.95254 13.8541 9.88244 13.9051L4.62013 17.7284C4.46338 17.8422 4.25249 17.689 4.31236 17.5048L6.32238 11.3185C6.34916 11.2361 6.31983 11.1459 6.24973 11.0949L0.987415 7.27163C0.830672 7.15775 0.911227 6.90983 1.10497 6.90983H7.60955C7.6962 6.90983 7.77299 6.85404 7.79976 6.77163L9.80979 0.58541Z"
                                fill="#ECB018"
                              />
                            </svg>
                          ))}
                        </div>
                        <p className="description">
                          “My son’s footwork and confidence have skyrocketed
                          since joining TFD! The coaches are so supportive, and
                          the flexible schedule makes it easy to balance club
                          commitments.”
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>

									{/* Testimonial Slide #2 */}
									<SwiperSlide>
										<div className="tf-testimonial-content">
											<div className="user-info">
												<img
													className="icon-testimonil"
													src="images/testimonial/Graphic.png"
													alt=""
												/>
												<div className="avata">
													<img
														src="images/testimonial/profile.jpg"
														alt="profile2"
													/>
												</div>
												<div className="info">
													<h6 className="name">David R.</h6>
													<p className="post">Parent of U12 Player</p>
												</div>
											</div>
											<div className="content">
												<div className="start">
													{/* 5 stars */}
													{[...Array(5)].map((_, i) => (
														<svg
															key={i}
															width={20}
															height={20}
															viewBox="0 0 20 20"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M9.80979 0.58541C9.86966 0.401148 10.1303 0.401148 10.1902 0.58541L12.2002 6.77163C12.227 6.85404 12.3038 6.90983 12.3904 6.90983H18.895C19.0888 6.90983 19.1693 7.15775 19.0126 7.27163L13.7503 11.0949C13.6802 11.1459 13.6508 11.2361 13.6776 11.3185L15.6876 17.5048C15.7475 17.689 15.5366 17.8422 15.3799 17.7284L10.1176 13.9051C10.0475 13.8541 9.95254 13.8541 9.88244 13.9051L4.62013 17.7284C4.46338 17.8422 4.25249 17.689 4.31236 17.5048L6.32238 11.3185C6.34916 11.2361 6.31983 11.1459 6.24973 11.0949L0.987415 7.27163C0.830672 7.15775 0.911227 6.90983 1.10497 6.90983H7.60955C7.6962 6.90983 7.77299 6.85404 7.79976 6.77163L9.80979 0.58541Z"
																fill="#ECB018"
															/>
														</svg>
													))}
												</div>
												<p className="description">
													“The coaching staff is phenomenal—professional,
													knowledgeable, and truly dedicated to each player’s
													development. We’ve already seen huge improvements in
													our son’s game.”
												</p>
											</div>
										</div>
									</SwiperSlide>

									{/* Testimonial Slide #3 */}
									<SwiperSlide>
										<div className="tf-testimonial-content">
											<div className="user-info">
												<img
													className="icon-testimonil"
													src="images/testimonial/Graphic.png"
													alt=""
												/>
												<div className="avata">
													<img
														src="images/testimonial/profile.jpg"
														alt="profile3"
													/>
												</div>
												<div className="info">
													<h6 className="name">Mia L.</h6>
													<p className="post">U13 Academy Player</p>
												</div>
											</div>
											<div className="content">
												<div className="start">
													{[...Array(5)].map((_, i) => (
														<svg
															key={i}
															width={20}
															height={20}
															viewBox="0 0 20 20"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M9.80979 0.58541C9.86966 0.401148 10.1303 0.401148 10.1902 0.58541L12.2002 6.77163C12.227 6.85404 12.3038 6.90983 12.3904 6.90983H18.895C19.0888 6.90983 19.1693 7.15775 19.0126 7.27163L13.7503 11.0949C13.6802 11.1459 13.6508 11.2361 13.6776 11.3185L15.6876 17.5048C15.7475 17.689 15.5366 17.8422 15.3799 17.7284L10.1176 13.9051C10.0475 13.8541 9.95254 13.8541 9.88244 13.9051L4.62013 17.7284C4.46338 17.8422 4.25249 17.689 4.31236 17.5048L6.32238 11.3185C6.34916 11.2361 6.31983 11.1459 6.24973 11.0949L0.987415 7.27163C0.830672 7.15775 0.911227 6.90983 1.10497 6.90983H7.60955C7.6962 6.90983 7.77299 6.85404 7.79976 6.77163L9.80979 0.58541Z"
																fill="#ECB018"
															/>
														</svg>
													))}
												</div>
												<p className="description">
													“TFD has pushed me to become a better player. The
													coaches focus on every detail—technique, fitness,
													mental strength—and I love training here!”
												</p>
											</div>
										</div>
									</SwiperSlide>

									{/* Navigation Arrows */}
									<div className="owl-controls">
										<div className="owl-nav">
											<div className="owl-prev h1p">prev</div>
											<div className="owl-next h1n">next</div>
										</div>
									</div>
								</Swiper>
							</div>
						</div>

						{/* Optional Additional Boxes */}
					</div>
				</div>
			</div>
		</div>
	);
}
